import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app';
import { enableMocking } from '@/app/mocks';

// Initialize i18n before rendering
import '@/shared/config/i18n';

// Start MSW (when VITE_USE_MOCK=true) before rendering so the first
// requests are intercepted; otherwise it's a no-op and the real API is used.
void enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
